module.exports = "/assets/src/client/assets/topLevelPage/styled-Switch.svg";